import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// fix default marker icons (bundler path issue)
const icon = (label, color) => L.divIcon({
  className: "cd-pin",
  html: `<div style="background:${color};width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 2px 6px rgba(0,0,0,.3);display:flex;align-items:center;justify-content:center;border:2px solid #fff"><span style="transform:rotate(45deg);color:#fff;font:700 11px 'IBM Plex Sans',sans-serif">${label}</span></div>`,
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

export default function MapOverview({ stages }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    mapRef.current = L.map(ref.current, { zoomControl: true, attributionControl: false, scrollWheelZoom: false })
      .setView([-28.5, 24.7], 5);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18 }).addTo(mapRef.current);
    layerRef.current = L.layerGroup().addTo(mapRef.current);
  }, []);

  useEffect(() => {
    const map = mapRef.current, layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = stages.filter((s) => s.lat && s.lng).map((s, i) => ({ ...s, order: i }));
    if (pts.length === 0) { map.setView([-28.5, 24.7], 5); return; }
    const latlngs = pts.map((p) => [p.lat, p.lng]);
    pts.forEach((p, i) => {
      L.marker([p.lat, p.lng], { icon: icon(String.fromCharCode(65 + i), "#0f172a") })
        .bindTooltip(`${p.name || p.type || "Stop"}`, { direction: "top", offset: [0, -22] })
        .addTo(layer);
    });
    if (latlngs.length > 1) L.polyline(latlngs, { color: "#0d9488", weight: 3, dashArray: "6 6" }).addTo(layer);
    const bounds = L.latLngBounds(latlngs);
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
    setTimeout(() => map.invalidateSize(), 100);
  }, [stages]);

  return <div ref={ref} className="w-full h-[300px] rounded-md overflow-hidden z-0" data-testid="route-map" />;
}
